module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley-rw"
  }, [_c('section', {
    staticClass: "frontmatter-rw preface-rw auto-rw page-open-left-rw",
    attrs: {
      "epub:type": "frontmatter preface",
      "id": "preface003"
    }
  }, [_c('h1', {
    staticClass: "preface-title-s"
  }, [_c('a', {
    attrs: {
      "id": "page-viii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/toc#toc-preface003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("START CLOSE IN")])]), _vm._v(" "), _c('div', {
    staticClass: "ext"
  }, [_c('p', {
    staticClass: "blockquote-firstpara"
  }, [_vm._v("Start close in,")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote-firstpara"
  }, [_vm._v("don’t take the second step")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote-firstpara"
  }, [_vm._v("or the third,")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote-firstpara"
  }, [_vm._v("start with the first")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote-firstpara"
  }, [_vm._v("thing")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote-firstpara"
  }, [_vm._v("close in,")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote-firstpara"
  }, [_vm._v("the step")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote-firstpara"
  }, [_vm._v("you don’t want to take.")])]), _vm._v(" "), _c('div', {
    staticClass: "ext"
  }, [_c('p', {
    staticClass: "blockquote-firstpara"
  }, [_vm._v("Start with")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote-firstpara"
  }, [_vm._v("the ground")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote-firstpara"
  }, [_vm._v("you know,")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote-firstpara"
  }, [_vm._v("the pale ground")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote-firstpara"
  }, [_vm._v("beneath your feet,")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote-firstpara"
  }, [_vm._v("your own")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote-firstpara"
  }, [_vm._v("way of starting")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote-firstpara"
  }, [_vm._v("the conversation.")])]), _vm._v(" "), _c('div', {
    staticClass: "ext"
  }, [_c('p', {
    staticClass: "blockquote-firstpara"
  }, [_vm._v("Start with your own")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote-firstpara"
  }, [_vm._v("question,")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote-firstpara"
  }, [_vm._v("give up on other")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote-firstpara"
  }, [_vm._v("people’s questions,")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote-firstpara"
  }, [_vm._v("don’t let them")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote-firstpara"
  }, [_vm._v("smother something")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote-firstpara"
  }, [_vm._v("simple.")])]), _vm._v(" "), _c('div', {
    staticClass: "ext"
  }, [_c('p', {
    staticClass: "blockquote-firstpara"
  }, [_vm._v("To find")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote-firstpara"
  }, [_vm._v("another’s voice,")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote-firstpara"
  }, [_vm._v("follow")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote-firstpara"
  }, [_vm._v("your own voice,")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote-firstpara"
  }, [_vm._v("wait until")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote-firstpara"
  }, [_vm._v("that voice")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote-firstpara"
  }, [_vm._v("becomes a")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote-firstpara"
  }, [_vm._v("private ear")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote-firstpara"
  }, [_vm._v("listening")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote-firstpara"
  }, [_vm._v("to another.")])]), _vm._v(" "), _c('div', {
    staticClass: "ext"
  }, [_c('p', {
    staticClass: "blockquote-firstpara"
  }, [_vm._v("Start right now")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote-firstpara"
  }, [_vm._v("take a small step")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote-firstpara"
  }, [_vm._v("you can call your own")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote-firstpara"
  }, [_vm._v("don’t follow")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote-firstpara"
  }, [_vm._v("someone else’s")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote-firstpara"
  }, [_vm._v("heroics, be humble")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote-firstpara"
  }, [_vm._v("and focused,")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote-firstpara"
  }, [_vm._v("start close in,")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote-firstpara"
  }, [_vm._v("don’t mistake")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote-firstpara"
  }, [_vm._v("that other")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote-firstpara"
  }, [_vm._v("for your own.")])]), _vm._v(" "), _c('div', {
    staticClass: "fsq"
  }, [_c('p', {
    staticClass: "blockquote-firstpara"
  }, [_c('em', [_vm._v("Start close in,")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote-firstpara"
  }, [_c('em', [_vm._v("don’t take")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote-firstpara"
  }, [_c('em', [_vm._v("the second step")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote-firstpara"
  }, [_c('em', [_vm._v("or the third,")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote-firstpara"
  }, [_c('em', [_vm._v("start with the first")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote-firstpara"
  }, [_c('em', [_vm._v("thing")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote-firstpara"
  }, [_c('em', [_vm._v("close in,")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote-firstpara"
  }, [_c('em', [_vm._v("the step")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote-firstpara"
  }, [_c('em', [_vm._v("you don’t want to take")])]), _vm._v(" "), _c('p', {
    staticClass: "attribution"
  }, [_c('em', [_vm._v("David Whyte")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f8587ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/preface003.vue
// module id = 69
// module chunks = 0